webpackJsonp([248570937730838],{

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin: 1rem 0;\n  padding: 1rem 2rem;\n  color: #3a87ad;\n  border: 4px solid #3a87ad;\n'], ['\n  margin: 1rem 0;\n  padding: 1rem 2rem;\n  color: #3a87ad;\n  border: 4px solid #3a87ad;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var AlertWarning = _styledComponents2.default.div(_templateObject);
	
	exports.default = AlertWarning;
	module.exports = exports['default'];

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Lead = __webpack_require__(43);
	
	var _Lead2 = _interopRequireDefault(_Lead);
	
	var _AlertInformation = __webpack_require__(22);
	
	var _AlertInformation2 = _interopRequireDefault(_AlertInformation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InitialConsulation = function InitialConsulation() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Your Initial Consultation'
	    ),
	    _react2.default.createElement(
	      _Lead2.default,
	      null,
	      'Your first visit may take up to 90 minutes and will be based upon the following:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'Completion of your own personal record card'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Brief explanation of chiropractic philosophy'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Medical examination'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Treatment (if safe and appropriate to do so)'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Post treatment advice'
	      )
	    ),
	    _react2.default.createElement(
	      _AlertInformation2.default,
	      null,
	      'For the examination and treatment, you will be asked to dress down to your underwear. A gown is available if you wish to wear one, otherwise please ensure suitable underwear is worn.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Record card and personal details'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Before a course of treatments can begin, it is imperative that a comprehensive record card be taken. This will include details of the presenting complaint, previous accidents (no matter how small or insignificant they may appear), previous operations/procedures, dental history, past illnesses, social/emotional well being and any family history of illness.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Chiropractic in a nutshell'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Once the record card has been taken, a brief explanation of what chiropractic is, and how it works will be given. If possible the explanation will relate to the patients condition to hopefully make it easier to digest and relate to.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Medical examination'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You will be asked to sign a declaration stating that you have had the purpose of chiropractic explained to you and that you give consent for a physical examination.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Depending on the nature of the complaint the following procedures may be carried out:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'General observation and gait analysis'
	      ),
	      'Vital signs (blood pressure, pulse rate, respiration and temperature)',
	      _react2.default.createElement(
	        'li',
	        null,
	        'Pulmonary examination'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Cardiovascular examination'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Abdominal examination'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Neurological examination'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Orthopaedic testing (specific to the presenting complaint)'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Cranial nerves examination'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Cerebral function testing'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Eyes, ears, nose and skin examination'
	      )
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Treatment'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'On completion of the medical examination a chiropractic working diagnosis of the condition will be presented along with a prognosis. A treatment plan will be offered and your consent to be treated requested.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'During the first treatment a brief explanation of each adjustment will be given prior to being carried out. This is mainly to put you at ease and to remove any unnecessary anxiety. The treatment can be stopped at any point with any questions/queries being answered.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If the chiropractor feels the condition warrants X-rays or further medical intervention you will be referred back to your GP. If the condition is deemed chronic and in need of immediate medical attention, you will referred straight to A & E.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The chiropractor reserves the right to refuse to treat.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Post treatment advice'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Following your treatment, you will be issued with a leaflet explaining what to expect post treatment. This will contain possible side affects and advice on how to look after yourself both immediately after treatment and for the long term future. Leaflets containing recommended stretching and muscle strengthening exercises may also be given but this depends on the individual case.'
	    )
	  );
	};
	
	exports.default = InitialConsulation;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-initial-consultation-js-25cf05f54b387f53f00e.js